import * as React from 'react';
import * as I18n from 'i18n-js';
import SanitizedRender from '@reverbdotcom/commons/dist/components/sanitized_render';
import AlertBox from '@reverbdotcom/commons/dist/components/alert_box';

export default function ContactReverb() {
  return (
    <div className="scaling-mb-2">
      <div className="payment-setup">
        <div className="payment-setup__info">
          <AlertBox color="blue">
            <SanitizedRender
              html={
                I18n.t('discovery.payoutMethod.contactReverb', {
                  linkOpen: '<a href="mailto:sellerengagement@reverb.com">',
                  linkClose: '</a>',
                })
              }
            />
          </AlertBox>
        </div>
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/src/components/contact_reverb.tsx